<template>
  <div>
    <div class="menu-title-right">
      <div class="actions">
        <loading-state :state="deleteState">Preparing...</loading-state>
        <button class="box" @click="createNewUser">Create New User</button>
      </div>
    </div>
    <h2>Cricket Chatbot</h2>
    <div class="chatbox-container">
      <div class="cricket chat-box">
        <div class="messages nobox">
          <div
            class="message"
            v-for="(msg, i) in messages"
            :key="i"
            :class="{'bot': msg.isBot, 'user': msg.isUser}"
            @mouseleave="hintIndex = null">
            <div 
              class="name">
              <span v-if="msg.isBot">Chatbot</span>
              <span v-else>{{chatUser.user.name}}</span>
              <span class="confident" v-if="msg.confident > 0">
                | <span 
                  @mouseover="hintIndex = i"
                  @click="(hintIndex === i)?hintIndex=null:true"
                  class="number"
                  :class="{
                  'high': msg.confident >= 0.75,
                  'medium': msg.confident < 0.75 && msg.confident >= 0.45,
                  'low': msg.confident < 0.45,}"
                >{{msg.confident * 100 | locale}}%</span></span>
            </div>
            <div class="helper-box" v-show="msg.isBot && hintIndex === i">
              <div class="helper"  v-if="msg.isBot">
                <div class="dl-box big-dd">
                  <dl>
                      <dt>Confident</dt>
                      <dd>{{msg.confident}}</dd>
                      <dt>Handler</dt>
                      <dd>{{msg.handler || '-'}}</dd>
                      <dt>Responder</dt>
                      <dd>{{msg.responder || '-'}}</dd>
                      <dt>Respond?</dt>
                      <dd>{{msg.userShouldRespond}}</dd>
                      <dt>Objects</dt>
                      <dd>{{Object.keys(msg.data) | join}}</dd>
                  </dl>
                </div>
              </div>
            </div>
            <div class="text">
              {{msg.message}}
            </div>
            <div class="attachments">
              <router-link 
                class="box border"
                v-for="team in msg.data.teams"
                :key="team.key"
                :to="{name: 'cricketTeam', params:{key: team.key}}">{{team.name}} Stats</router-link>
              <router-link 
                class="box border"
                v-for="player in msg.data.players"
                :key="player.key"
                :to="{name: 'cricketPlayer', params:{key: player.key}}">{{player.card_name}} Stats</router-link>
              <router-link 
                class="box border"
                v-for="match in msg.data.matches"
                :key="match.key"
                :to="{name: 'cricketMatch', params:{key: match.key}}">{{match.card_name}}</router-link>
            </div>
          </div>
        </div>
        <div class="bottom-tools">
          <div class="suggestions" v-if="lastMessage && lastMessage.data && lastMessage.data.conflicts">
            <button
              v-for="player in lastMessage.data.conflicts.players"
              :key="player.key"
              @click="selectSuggestion(player.card_name)"
            >{{player.card_name}}</button>
          </div>
          <div>
            <loading-state :state="sendingState"></loading-state>
            <div v-if="!sendingState.isLoading()" class="input-box">
              <input @keyup.enter="sendMsg" type="text" v-model="userText" placeholder="Your message here">
              <button @click="sendMsg" class="black">Send</button>
            </div>
          </div>
        </div>
      </div>
      <div class="cricket chat-iframe">
        <iframe :src="chatbotIframeURL" width="100%" height="650"></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'
import Config from '@/config'
import { CricketChatUser, ChatMessage } from '@/models/cricket/chatbot'


export default {
  props: {
    'chatUser': Object
  },
  data () {
    if (ChatMessage.State.messages.length === 0) {
      const msg = ChatMessage.buildWelcome(CricketChatUser.State.user.user)
      ChatMessage.State.messages.push(msg)

      // ChatMessage.State.messages.push(new ChatMessage(
      //   'I am Good. How are you?', false, true
      // ))

      // const msg1 = new ChatMessage(
      //   'Next match is good', true
      // )
      // msg1.confident = 0.9
      // ChatMessage.State.messages.push(msg1)

    }

    return {
      messages: ChatMessage.State.messages,
      hintIndex: null,
      userText: '',
      // userText: 'Last match of Sharma?',
      lastMessage: null,
      sendingState: DataState.newNotInit(),
      deleteState: DataState.newNotInit(),
      chatbotIframeURL: 'https://www.cricketapi.com/chatbot-iframe/?app_key=' + Config.RSDemoAppKey +'&user_key=' + CricketChatUser.State.user.chat_userkey + '&name=' + CricketChatUser.State.user.user.name,
    }
  },
  methods: {
    createNewUser () {
      this.deleteState.changeToLoading()
      this.chatUser.deleteUser().then(chatUser => {
        this.chatUser.updateUserStatus(chatUser)
        CricketChatUser.State.user = this.chatUser
        this.deleteState.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.deleteState.changeToError(error)
      })
    },

    sendMsg () {
      this.sendingState.changeToLoading()
      this.chatUser.answer(this.userText).then(msgs => {
        this.messages.push(new ChatMessage(this.userText, false, true))
        msgs.forEach((msg) => {
          this.messages.push(msg)
        })

        if (msgs.length > 0) {
          this.lastMessage = msgs[msgs.length-1]
        } else {
          this.lastMessage = null
        }
        // this.messages.concat(msgs)
        this.userText = ''
        this.sendingState.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.sendingState.changeToError(error)
      })
    },

    selectSuggestion (text) {
      this.userText = text
      this.sendMsg()
    }
  }
}
</script>

